export { SoldOut } from '../styles'
